import React from 'react';
import type { RouteObject } from 'react-router-dom';
import RequireRole from '../../shared/guards/RequireRole';
import Dashboard from './Dashboard';
import ActionSelector from './ActionSelector';
import DailyClosing from './DailyClosing';
import CashWithdrawal from './CashWithdrawal';
import CashSpending from './CashSpending';
import CashAddition from './CashAddition';

const cashAllowed = ['Owner', 'Admin', 'Manager', 'Employee'];

const guarded = (children: React.ReactElement) => (
  <RequireRole allowedRoles={cashAllowed}>{children}</RequireRole>
);

export const cashRoutes: RouteObject[] = [
  {
    path: 'cash',
    children: [
      { index: true, element: guarded(<Dashboard />) },
      { path: 'new', element: guarded(<ActionSelector />) },
      { path: 'daily-closing', element: guarded(<DailyClosing />) },
      { path: 'withdrawal', element: guarded(<CashWithdrawal />) },
      { path: 'spending', element: guarded(<CashSpending />) },
      { path: 'add', element: guarded(<CashAddition />) },
    ],
  },
];
